import React, { useState } from "react";
import { images } from "../../common/images";
import "./style.scss";
import { TextField } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SearchIcon from "@mui/icons-material/Search";

export function MaterialInputField({
  placeholder,
  icon,
  searchIcon,
  isPassword,
  error,
  fullWidth,
  handleChange,
  handleBlur,
  phone,
  validate,
  value,
  label,
  disabled,
  prefixerValue,
  customSign,
  customStyle,
  isSearch,
  onFocus,
  ...props
}) {
  const { eyeOpen, eyeClose } = images;
  const [isEyeOpen, setIsEyeOpen] = useState(false);

  return (
    <>
      <div
        className={
          fullWidth
            ? `input-field-container full-width-input-generic ${customStyle}`
            : `input-field-container ${customStyle} ${
                disabled ? "disable-input-field" : ""
              }`
        }
      >
        {phone && (
          <div className="additonal-one">
            <span> +</span>
          </div>
        )}
        {prefixerValue && (
          <div className="additonal-prefixes">
            <span>{prefixerValue}</span>
          </div>
        )}
        {customSign && (
          <div className="additonal-customSign">
            <span>{customSign}</span>
          </div>
        )}

        <TextField
          fullWidth
          disabled={disabled}
          value={value}
          label={label} // Use `label` instead of `placeholder`
          autoComplete="off"
          id={`${label}-input`}
          className={
            disabled ? "isDisabled input-field-generic" : "input-field-generic"
          }
          type={
            isPassword && !isEyeOpen ? "password" : isSearch ? "search" : "text"
          }
          onFocus={onFocus}
          onChange={handleChange}
          onBlur={handleBlur}
          validate={validate}
          sx={{
            boxShadow: "none",
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
          }}
          InputLabelProps={{
            shrink: value ? true : undefined, // Let it animate based on value
          }}
          InputProps={{
            placeholder: placeholder, // Add placeholder separately
            startAdornment: icon && (
              <InputAdornment position="start">
                <IconButton>{icon}</IconButton>
              </InputAdornment>
            ),
            endAdornment: (
              <>
                {searchIcon && (
                  <InputAdornment position="end">
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                )}
                {isPassword && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setIsEyeOpen(!isEyeOpen);
                      }}
                    >
                      {isEyeOpen ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )}
              </>
            ),
          }}
          {...props}
        />
      </div>
      <div className="error-input-container">
        {error ? <p className="form-error">{error}</p> : null}
      </div>
    </>
  );
}
